/* APP JS & SCSS */
import "./js/lazy-loading.js"
import "./js/cookie-box"
import "./sass/app.scss"
